export const autoTabFields = (elemSelector: string) => {
  const inlineFieldsWrapper: NodeListOf<HTMLElement> = document.querySelectorAll(elemSelector);
  if (inlineFieldsWrapper.length === 0) return;

  inlineFieldsWrapper.forEach(inlineField => {
    const inlineInputs: NodeListOf<HTMLInputElement> = inlineField.querySelectorAll('input');
    inlineInputs.forEach((input) => {

      input.addEventListener('input', () => {
        validateLength(input);
      });

      if (input.dataset.type === 'number') {
        input.addEventListener('blur', (e) => {
          fixNumber(e);
        });

        input.addEventListener('input', (e) => {
          tabToNext(input, e);
        });
      }

      if (input.dataset.type === 'year') {
        input.addEventListener('blur', () => {
          fixYear(input);
        });
      }
    });
  })

  function isInRange(current: number, low: number, high: number) {
   return current >= low && current <= high;
  }

  function fixYear(input: HTMLInputElement) {
    if(input.dataset.type !== 'year') return;

    let yearLength = input.value.length;
    let year = parseInt(input.value);

    if (yearLength === 2) {
      let yearPrefix = (year >= 29 && year <= 99) ? '19' : '20';
      input.value = `${yearPrefix}${year}`;

      triggerChange(input);
    }
  }

  function triggerChange(input: HTMLInputElement) {
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function fixNumber(e: Event) {
    const input = e.target as HTMLInputElement;
    const inputValue = input.value;

    if(inputValue.length > 1) return;

    if (inputValue.length == 1 && parseInt(inputValue) > 0) {
      input.value = `0${inputValue}`;
      triggerChange(input);
    }
  }

  function validateLength(input: HTMLInputElement) {
    var maxLength = input.maxLength;

    if (input.value.length > maxLength) {
      input.value = input.value.slice(0, maxLength);
      triggerChange(input);
    }
  }

  function tabToNext(input: HTMLInputElement, e: Event) {
    const target = e.currentTarget as HTMLInputElement;
    const inputValue = parseInt(target.value);
    const inputMin = parseInt(target.min);
    const inputMax = parseInt(target.max);

    if (isInRange(inputValue, inputMin, inputMax) && input.value.length === 2) {
      let nextInput = input.parentElement.nextElementSibling.querySelector('input');

      if(nextInput.tagName.toLowerCase() === 'input') {
        nextInput.focus();
      }
    }
  }

}